import Icon from '../components/Icon.vue'

Icon.register({
  'shopping-basket': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 216v16c0 13.3-10.7 24-24 24h-8l-26.1 182.8c-3.4 23.6-23.6 41.2-47.5 41.2h-364.7c-23.9 0-44.1-17.6-47.5-41.2l-26.1-182.8h-8c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h67.3l106.8-146.8c10.4-14.3 30.4-17.5 44.7-7.1 14.3 10.4 17.5 30.4 7.1 44.7l-79.4 109.2h235l-79.4-109.2c-10.4-14.3-7.2-34.3 7.1-44.7 14.3-10.4 34.3-7.2 44.7 7.1l106.8 146.8h67.3c13.3 0 24 10.7 24 24zM312 392v-112c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zM424 392v-112c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zM200 392v-112c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shopping-basket.js
// module id = 1885
// module chunks = 0